module.exports = __webpack_public_path__ + "img/album23_03.6ba4fefb.jpg";